const Tape1 = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 102 91"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8" filter="url(#filter0_d_3122_16472)">
        <path
          d="M92.2752 35.0126L93.3587 31.957C95.5255 25.8462 96.0672 24.3186 94.5396 23.7769C90.6688 22.376 86.6356 21.4729 82.537 21.0895C76.645 20.5653 73.5964 19.7921 72.513 22.8473C71.7507 24.9972 71.737 27.417 70.2156 30.3841C70.1699 30.3626 70.122 30.3473 70.0762 30.3262C69.3974 31.3924 68.6751 32.4736 68.0728 33.4253C64.0768 38.9373 60.7246 42.0812 54.9254 45.2238C49.1742 48.3385 42.7019 49.7517 36.4419 49.9445C33.6007 50.0324 30.5802 50.1705 27.7437 50.0642C25.5148 49.9824 23.2566 49.1629 21.0893 48.7126C19.2133 48.3068 17.3679 47.7707 15.5665 47.1083C14.7597 46.8414 13.8806 46.9008 13.1171 47.2739C12.3536 47.6469 11.7664 48.3039 11.4812 49.1043C9.77765 53.8933 8.14484 58.4841 6.31114 63.6553C6.09976 64.2557 6.12084 64.9135 6.37023 65.4992C6.61963 66.0848 7.07926 66.5558 7.65862 66.8195C8.80771 67.2983 9.98803 67.6985 11.1914 68.0171C13.382 68.6975 14.6 69.1088 16.7879 69.7968C20.3387 70.8572 24.003 71.492 27.7037 71.6879C31.3129 71.9369 34.8381 72.5594 38.5604 72.1444C44.6863 71.4563 50.7206 70.5023 56.5874 68.419C60.8206 66.8706 64.8244 64.7554 68.4893 62.1312C69.6307 61.3958 70.7793 60.3824 71.6893 59.7903C73.7799 58.4806 75.7657 57.0107 77.6289 55.3938C79.2913 53.933 80.8658 52.3752 82.3443 50.7285C84.1186 48.7582 86.3915 46.2992 87.772 44.0593C89.3313 41.5287 90.3772 39.8218 91.4245 37.9298C91.3704 37.9129 92.3312 35.0289 92.2752 35.0126ZM11.5327 59.4394L11.7177 58.7484C13.0094 59.141 14.3012 59.5332 15.5932 59.925L15.3833 60.6914L11.5327 59.4394ZM16.1483 53.616L16.2794 52.9934C16.9632 53.0587 17.6476 53.1236 18.3325 53.1881C18.3311 53.3767 18.3328 53.5664 18.3294 53.7543L16.1483 53.616ZM38.0458 61.0626L37.9815 61.738C36.4256 61.5664 34.8695 61.3941 33.3132 61.2211C33.34 60.9467 33.3678 60.6727 33.3967 60.3991L38.0458 61.0626ZM17.9936 67.1332C18.0832 66.8123 18.1715 66.4913 18.2605 66.1719C20.0726 66.6391 21.8845 67.1068 23.6965 67.5751C23.6392 67.8237 23.5836 68.0729 23.5264 68.3215L17.9936 67.1332ZM27.129 61.741L30.7644 62.3386C30.737 62.5131 30.7115 62.686 30.6858 62.8611C29.4702 62.681 28.2552 62.5007 27.0407 62.3201L27.129 61.741ZM28.4855 65.8595L28.5805 65.2276L31.6318 65.7113C31.5921 65.9585 31.5539 66.208 31.514 66.4556L28.4855 65.8595ZM36.4873 65.9822C36.4577 65.7257 36.4288 65.4685 36.4017 65.2124C37.8843 65.033 39.3668 64.8547 40.8491 64.6776L40.9009 65.7828C39.4309 65.8484 37.9597 65.9148 36.4873 65.9822ZM59.5636 62.4325C55.9816 63.5135 52.2795 64.4327 48.6089 65.3931C48.189 64.6131 47.839 65.2994 47.4164 64.522C51.1938 63.4624 54.9688 62.4045 58.9627 61.2831C59.312 62.5718 59.8274 62.3521 59.5643 62.4305L59.5636 62.4325ZM69.7348 55.2971L69.1504 54.6462C70.2371 53.6332 71.3236 52.6209 72.4099 51.6092L72.9794 52.2392C71.8982 53.2574 70.8167 54.2767 69.7348 55.2971ZM78.1169 50.8501C77.9992 50.9733 77.7492 50.9658 77.56 51.0188L77.4146 50.0386C78.2128 49.3397 79.1438 48.5229 80.0765 47.7063C80.2531 47.8478 80.4294 47.9914 80.607 48.1351C79.7811 49.0425 78.9624 49.9596 78.1169 50.8501ZM79.7912 45.6582L78.7482 44.4628C80.314 43.0299 81.8801 41.5961 83.4466 40.1613L84.022 40.7405L79.7912 45.6582Z"
          fill="#E6B941"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3122_16472"
          x="0.166595"
          y="17.5992"
          width="101.243"
          height="63.6842"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3122_16472"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3122_16472"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default Tape1;
